import { useContext, useMemo } from 'react';

import { RolesContext } from './rolesContext';
import { useFeatureFlags } from './useFeatureFlags';

export const useRoles = () => {
  const context = useContext(RolesContext);

  if (!context) {
    throw new Error('useRoles must be used within a RolesProvider');
  }

  const { securityScan } = useFeatureFlags();

  const permissions = useMemo(
    () =>
      Object.fromEntries(
        Object.entries(context.permissions).filter(
          ([key]) => securityScan || key !== 'Manage ransomware detection'
        )
      ),
    [context.permissions, securityScan]
  );

  return {
    ...context,
    permissions,
  };
};
